import React from 'react';
import { useLocalStore } from "mobx-react";
import { ViewModel } from "./ViewModel";
import { ViewModelInstance } from "./ViewModel";
import { events, EventsChannel } from 'aws-amplify/api';
declare global {
  interface Window { store: any; user : () => { id : string } }
}

const authToken = window._env_.RTC_TOKEN;
let gameChannel: EventsChannel;
let gameChannelID: string | undefined;

const getGameChannel = async (gameID: string) => {
  if (!gameChannel || gameChannelID != gameID) {
    gameChannel = await events.connect(`/application/game`, { authToken });
    gameChannelID = gameID;
  }
  return gameChannel;
}

const storeContext = React.createContext<ViewModelInstance | null>(null);

const createStore = () => ViewModel.create({
  user : (window.user && window.user()) || null,
}, {
  getGameChannel,
})


export const StoreProvider : React.SFC = ({ children }) => {
  const store = useLocalStore(createStore);
  window.store = store;
  return <storeContext.Provider value={store}>{children}</storeContext.Provider>
}

export const useStore = () => {
  const store = React.useContext(storeContext);
  if (!store) { throw new Error(`useStore must be used within a StoreProvider`) }
  else return store;
}
